// extracted by mini-css-extract-plugin
export default {"spanClick":"style_spanClick__6nH5o","container":"style_container__+s3As","upLogo":"style_upLogo__wEy16","fileRow":"style_fileRow__rnkl0"};